import { Bell } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { api } from "@/lib/api";

export default function ReminderButton({ booking }) {
    async function send() {
        try {
            await api.post(`/admin/bookings/${booking.id}/reminder`, {});
            toast.success(`Reminder sent to ${booking.email}`);
        } catch {
            toast.error("Could not send reminder");
        }
    }
    return (
        <Button
            size="sm"
            variant="outline"
            onClick={send}
            className="rounded-full text-xs"
            data-testid={`reminder-btn-${booking.reference_id}`}
        >
            <Bell size={12} className="mr-1" /> Remind
        </Button>
    );
}
